import React, { useState, useEffect, useRef } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";

interface MoveTaskProps {
  isOpen: boolean;
  toggleModal: () => void;
  moveTask: () => void;
}


const MoveTaskModal: React.FC<MoveTaskProps> = ({
  isOpen,
  toggleModal,
  moveTask
}) => {


  return (
    <Modal 
    className={`${localStorage.getItem('mode') ? localStorage.getItem('mode') : 'light'}`} 
    isOpen={isOpen}>
    <ModalHeader className="modal-header-style theme-text-color">Mover tarefa</ModalHeader>
    <ModalBody className="modal-body-style">

        <strong
        className="theme-text-color"
        >Você tem certeza que deseja mover a tarefa?
        </strong>
      
    </ModalBody>
    <ModalFooter className="modal-footer-style">
      <Button
        color="primary"
        onClick={()=> {
          moveTask()
          toggleModal()
        }}
        id="btn-move-task"
      >
        Confirmar
      </Button>{" "}
      <Button color="secondary" onClick={toggleModal}>
        Cancelar
      </Button>
    </ModalFooter>
  </Modal>
  );
};

export default MoveTaskModal;
